<template>
  <div class="identity">
    <Navbar :title="'设置身份'"></Navbar>
    <img class="logo" src="@/assets/image/logo.png" alt="" />
    <!-- <div class="title">设置身份</div> -->
    <div class="btns">
      <div class="btn" @click="setIdentity(0)">
        <img src="@/assets/image/user.png" alt="" />
        <span>终端用户</span>
      </div>
      <div class="btn" @click="setIdentity(1)">
        <img src="@/assets/image/user1.png" alt="" />
        <span>制冷厂商</span>
      </div>
      <div class="btn" @click="setIdentity(2)">
        <img src="@/assets/image/shifu.png" alt="" />
        <span>维修师傅</span>
      </div>
      <div class="btn" @click="setIdentity(3)">
        <img src="@/assets/image/shifu.png" alt="" />
        <span>模具配件</span>
      </div>
    </div>
  </div>
</template>

<script>
import Tabber from "../components/Tabber";
import Navbar from "../components/Navbar";
import {
  indexOp,
  updateOp,
  deleteOp,
  addOp,
  showOp,
  uploadImg,
  uploadFile,
} from "../api/index";
import base from "../api/base";
export default {
  components: { Navbar, Tabber },
  data() {
    return {
      peijianDetail: "",
      shopDetail: "",
      companyDetail: "",
      userInfo: "",
    };
  },
  created() {},
  methods: {
    setIdentity(type) {
      var _this = this;
      _this.$toast.loading({
        message: "",
        forbidClick: true,
      });
      var data = {
        identity: type,
      };
      addOp("/user/update/1", data).then((res) => {
        _this.$toast.clear();
        if (res && res.status == 200) {
          _this.userInfo = res.data;
          _this.$cookies.set("identity", res.data.identity);
          _this.$cookies.set("userInfo", res.data);
          if (res.data.identity == 0) {
            if (!res.data.mobile) {
              _this.$router.push("/editUserinfo");
            } else {
              _this.$router.push("/user");
            }
          } else if (res.data.identity == 1) {
            _this.getCompanyDetail();
          } else if (res.data.identity == 2) {
            _this.getShopDetail();
          } else if (res.data.identity == 3) {
            _this.getPeijianDetail();
          }
        }
      });
    },
    //获取配件模具详情
    getPeijianDetail() {
      var _this = this;
      var data = {
        uid: _this.userInfo.id,
      };
      indexOp("/fitting_user/show/1", data).then((res) => {
        _this.$toast.clear();
        if (res && res.status == 200) {
          _this.peijianDetail = res.data;
          if (_this.peijianDetail == "") {
            _this.$router.push("/editPeijianinfo");
          } else {
            _this.$router.push("/user");
          }
        }
      });
    },
    //获取制冷厂商详情
    getCompanyDetail() {
      var _this = this;
      var data = {
        uid: _this.userInfo.id,
      };
      indexOp("/company_user/show/1", data).then((res) => {
        if (res && res.status == 200) {
          _this.companyDetail = res.data;
          if (_this.companyDetail == "") {
            _this.$router.push("/editShopinfo");
          } else {
            _this.$router.push("/user");
          }
        }
      });
    },
    //获取店铺详情
    getShopDetail() {
      var _this = this;
      var data = {
        uid: _this.userInfo.id,
      };
      indexOp("/service_user/show", data).then((res) => {
        if (res && res.status == 200) {
          _this.shopDetail = res.data;
          if (_this.shopDetail == "") {
            _this.$router.push("/editShifuinfo");
          } else {
            _this.$router.push("/user");
          }
        }
        console.log(res);
      });
    },
  },
};
</script>

<style>
</style>